import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericDialogResult } from '../generic-mat-dialog/generic-dialog-result';

export interface ConfirmActionModalInput
{
    confirmButton: string;
    cancelButton?: string;
    content: string;
    title: string;
}

@Component({
    selector: 'app-confirm-action-modal',
    templateUrl: './confirm-action-modal.component.html',
})
export class ConfirmActionModalComponent
{
    constructor(
            private _dialogRef: MatDialogRef<ConfirmActionModalComponent>,
            @Inject(MAT_DIALOG_DATA) public data: ConfirmActionModalInput,
    ) {
        if(!this.data.title) {
            this.data.title = 'Please Confirm';
        }
    }

    closeAndConfirm() {
        this._dialogRef.close(<GenericDialogResult>{success: true});
    }

    closeAndCancel() {
        this._dialogRef.close(<GenericDialogResult>{success: false});
    }

}
